<template>
  <div class="top-hero2">
    <div class="container">
      <div id="challange-target">hidden</div>

      <div class="marginTop d-flex justify-content-md-center">
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Response</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>

              <v-card-text>
                <h3 class="text-dark">We sent you a password reset email</h3>
              </v-card-text>

              <v-card-text> </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>
